import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles({
  contentMain: {
    height: "100%",
  },
  vehiculeRoot: {
    padding: "30px clamp(16px, 3vw, 30px)",
    overflowY: "auto",
    height: "100%",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  subContainer: {
    borderRadius: "16px",
    padding: "28px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
  },
  containerRoot: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  subContainerStepper: {
    borderRadius: "14px",
    padding: "32px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: colors.bgcolor,
  },
  subsubContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 0",
    gap: "8px",
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "8px 16px",
    gap: "16px",
    width: "100%",
  },
});

export default useStyles;
